export enum DefinitionType {
  FIT = 'FIT',
  FORMAT = 'FORMAT',
  INTERSECTION_TYPE = 'INTERSECTION_TYPE',
  LICENSE_TYPE = 'LICENSE_TYPE',
  QUADRANT = 'QUADRANT',
  SHOPPING_CENTER_TYPE = 'SHOPPING_CENTER_TYPE',
  STORE_STATUS = 'STORE_STATUS'
}
